import { AccountLevelEnum, AccountStatusEnum, SnackBarVariants } from '@app/app.enum';
import { history } from '@app/app.routes';
import store from '@app/app.store';
import AccountAppViewComponent from '@app/components/account/app/account-app-view.component';
import { withAxiosCancellation } from '@app/components/core/axios-cancel.component';
import withSnackBar from '@app/components/core/message.component';
import Icon from '@app/components/shared/icon.component';
import ProductDetailsComponent from '@app/components/shared/product-details.component';
import * as models from '@app/models';
import { ICustomerAccountDetailsState } from '@app/models';
import Injector from '@app/services';
import { AdminAccountService } from '@app/services/admin-account.service';
import { SharedService } from '@app/services/shared.service';
import { USPSTierConfigService } from '@app/services/usps-tier-config.service';
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	CircularProgress,
	Grid,
	Typography,
	withStyles
} from '@material-ui/core';
import { StyleRules } from '@material-ui/core/styles';
import Axios from 'axios';
import * as React from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';
import AdjustBalanceComponent from './admin-account-adjust-balance.component';
import AdminAccountRateSetComponent from './admin-account-rateset.component';
import AdminAccountUserListComponent from './admin-account-user-list.component';
import AdminAccountUSPSTierComponent from './admin-account-usps-tier.component';
import AdminDetailsComponent from './admin-details.component';

const styles: StyleRules = {
	keyInput: {
		fontSize: 16,
		padding: '10px 14px',
	},
	textLabel: {
		fontSize: 18,
	},
};

const sharedService: SharedService = Injector.get(SharedService);
const uspsTierConfigService: USPSTierConfigService = Injector.get(USPSTierConfigService);
const adminAccountService: AdminAccountService = Injector.get(AdminAccountService);

class AdminAccountDetailsComponent extends React.Component<
	models.IAdminCustomerProps,
	models.ICustomerAccountDetailsState
> {
	public isPartnerAccount: boolean;
	constructor(props: models.IAdminCustomerProps) {
		super(props);
		this.state = models.initialAdminAccountDetailsState();
		this.isPartnerAccount = store.getState().authentication.user.account.level === AccountLevelEnum.Partner;
	}

	public async componentDidMount() {
		const accountId =
			(this.props.match.params as any).accountId || (history.location.state && history.location.state.account.id);
		const customerAccountDetails = await adminAccountService.getAccountByAccountId(accountId);
		await this.getAllUsersByAccountIdForAdmin(accountId);
		await this.getUSPSTierConfigs(accountId);
		await this.getRateSets(customerAccountDetails.account.name);

		this.setState({
			...customerAccountDetails,
			uspsTierConfig: {
				selected: customerAccountDetails.account.uspsTierConfig ?? models.NoneUSPSTierData(),
				current: customerAccountDetails.account.uspsTierConfig ?? models.NoneUSPSTierData(),
			},
		});
	}

	public render() {
		return (
			<React.Fragment>
				<Grid container={true} direction='row' spacing={2}>
					<Grid item={true} lg={12} md={12} sm={12} xs={12}>
						<Accordion defaultExpanded={true}>
							<AccordionSummary expandIcon={<Icon name='chevron-down' />}>
								<Typography variant='h6' color='inherit'>
									{this.props.intl.formatMessage({
										id: 'app.component.admin-account-details',
									})}
								</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<AdminDetailsComponent
									intl={this.props.intl}
									location={this.props.location}
									match={this.props.match}
									customerAccount={this.state.account}
									updateAccountStatus={this.updateAccountStatus}
									partnerVisibleAccountNum={this.state.partnerVisibleAccountNum}
									visibleAccountNumber={this.state.visibleAccountNumber}
									shipmentCount={this.state.shipmentCount}
								/>
							</AccordionDetails>
						</Accordion>
					</Grid>
					{/* Users Accordion */}
					{this.state.account.level === AccountLevelEnum.Customer ? (
						<Grid item={true} lg={12} md={12} sm={12} xs={12}>
							<Accordion>
								<AccordionSummary expandIcon={<Icon name='chevron-down' />}>
									<Typography variant='h6' color='inherit'>
										{this.props.intl.formatMessage({
											id: 'admin-account-user-list.acccordion-label',
										})}
									</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<AdminAccountUserListComponent
										intl={this.props.intl}
										location={this.props.location}
										match={this.props.match}
										users={this.state.users}
										accountId={this.state.account.id}
										accountStatus={this.state.account.status}
									/>
								</AccordionDetails>
							</Accordion>
						</Grid>
					) : null}

					{/*  Balance & Adjustments */}
					{this.state.account.level === AccountLevelEnum.Customer ? (
						<Grid item={true} lg={12} md={12} sm={12} xs={12}>
							<Accordion>
								<AccordionSummary
									expandIcon={<Icon name='chevron-down' />}
									aria-controls='panel1a-content'
									id='panel1a-header'
								>
									<Typography variant='h6' color='inherit'>
										{this.props.intl.formatMessage({
											id: 'app.account-details.account-balance-adjustment',
										})}
									</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<AdjustBalanceComponent
										updateAccountBalance={this.updateBalance}
										match={this.props.match}
										account={this.state.account}
										balance={this.state.balance}
										isPartnerAccount={this.isPartnerAccount}
									/>
								</AccordionDetails>
							</Accordion>
						</Grid>
					) : null}
					{/* Tier & override rateset*/}
					{this.state.account.id && (
						<>
							<Grid item={true} lg={12} md={12} sm={12} xs={12}>
								<Accordion>
									<AccordionSummary
										expandIcon={<Icon name='chevron-down' />}
										aria-controls='panel1a-content'
										id='panel1a-header'
									>
										<Typography variant='h6' color='inherit'>
											{this.props.intl.formatMessage({
												id: 'app.account-details.usps-config',
											})}
										</Typography>
									</AccordionSummary>
									<AccordionDetails>
										<AdminAccountUSPSTierComponent
											uspsConfigdataLoading={this.state.uspsConfigdataLoading}
											buttonLoading={this.state.buttonLoading}
											account={this.state.account}
											isPartnerAccount={this.isPartnerAccount}
											partnerUSPSTier={this.state.partnerUSPSTier}
											uspsTierConfig={this.state.uspsTierConfig}
											uspsTierConfigs={this.state.uspsTierConfigs}
											updateUSPSTierConfig={this.updateUSPSTierConfig}
											onSetUSPSTierConfig={(tierConfig) => {
												this.setState((prevState) => ({
													uspsTierConfig: {
														...prevState.uspsTierConfig,
														selected: tierConfig,
													},
												}));
											}}
										/>
									</AccordionDetails>
								</Accordion>
							</Grid>
							<Grid item={true} lg={12} md={12} sm={12} xs={12}>
								<Accordion>
									<AccordionSummary
										expandIcon={<Icon name='chevron-down' />}
										aria-controls='panel1a-content'
										id='panel1a-header'
									>
										<Typography variant='h6' color='inherit'>
											{this.props.intl.formatMessage({
												id: 'app.account-details.rateset',
											})}
										</Typography>
									</AccordionSummary>
									<AccordionDetails>
										<AdminAccountRateSetComponent
											rateSetdataLoading={this.state.rateSetdataLoading}
											buttonLoading={this.state.buttonLoading}
											rateSets={this.state.rateSets}
											uniqueRateSetCarrier={this.state.uniqueRateSetCarrier}
										/>
									</AccordionDetails>
								</Accordion>
							</Grid>
						</>
					)}
					{/* Apps */}
					{this.state.account.level === AccountLevelEnum.Customer ? (
						<Grid item={true} lg={12} md={12} sm={12} xs={12}>
							<Accordion>
								<AccordionSummary
									expandIcon={<Icon name='chevron-down' />}
									aria-controls='panel1a-content'
									id='panel1a-header'
								>
									<Typography variant='h6' color='inherit'>
										{this.props.intl.formatMessage({
											id: 'app.component.app',
										})}
									</Typography>
								</AccordionSummary>
								<AccordionDetails>
									{!!this.state.apps.length ? (
										<AccountAppViewComponent
											history={history}
											apps={this.state.apps}
											isPartnerAccount={this.isPartnerAccount}
										/>
									) : (
										<Grid container={true} justifyContent='center'>
											<Grid item={true}>
												<CircularProgress size={24} />
											</Grid>
										</Grid>
									)}
								</AccordionDetails>
							</Accordion>
						</Grid>
					) : null}
					{/* Product */}
					{this.state.account.level === AccountLevelEnum.Customer ? (
						<Grid item={true} lg={12} md={12} sm={12} xs={12}>
							<Accordion>
								<AccordionSummary
									expandIcon={<Icon name='chevron-down' />}
									aria-controls='panel1a-content'
									id='panel1a-header'
								>
									<Typography variant='h6' color='inherit'>
										{this.props.intl.formatMessage({
											id: 'app.account-details.plans-label',
										})}
									</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<ProductDetailsComponent account={this.state.account} isPartnerAccount={this.isPartnerAccount} />
								</AccordionDetails>
							</Accordion>
						</Grid>
					) : null}
				</Grid>
			</React.Fragment>
		);
	}

	private updateBalance = (accountBalance: number) => {
		this.setState({ balance: accountBalance });
	};

	/**
	 * In Tier Config dropdown, Display only PartnerTier and those tiers which are not yet assigned to any account.
	 * @param accountId id of account, which admin is viewing the details
	 */
	private getUSPSTierConfigs = async (accountId: string) => {
		try {
			const res = await uspsTierConfigService.getUSPSTierConfigsForAccount(accountId);
			res.unshift(models.NoneUSPSTierData());
			res.push(models.AddNewUSPSTierData());
			this.setState({
				uspsTierConfigs: res,
				uspsConfigdataLoading: false
			});
		} catch (error) {
			if (!Axios.isCancel(error)) {
				this.props.openSnackBar(sharedService.parseError(error.data), SnackBarVariants.Error);
			}
		}
	};

	private getRateSets = async (companyName: string) => {
		try {
			this.setState((prevState: models.ICustomerAccountDetailsState) => ({
				rateSetdataLoading: true,
				uspsTierConfig: {
					...prevState.uspsTierConfig,
					selected: prevState.uspsTierConfig.current,
				},
			}));
			const res = await adminAccountService.getRateSets(companyName);
			let customerRateSet = res.rateSets;

			if(!customerRateSet){
				customerRateSet = []
			}
			const uniqueCarrierName = customerRateSet ? [...new Set(customerRateSet.map((e) => e.carrier))] : null;

			this.setState((prevState: models.ICustomerAccountDetailsState) => ({
				rateSetdataLoading: false,
				rateSets: customerRateSet,
				uniqueRateSetCarrier: uniqueCarrierName,
			}));
		} catch (error) {
			if (!Axios.isCancel(error)) {
				this.props.openSnackBar(sharedService.parseError(error.data), SnackBarVariants.Error);
			}
		}
	};

	private updateUSPSTierConfig = async () => {
		try {
			const {
				uspsTierConfig: {
					selected: { id: uspsTierId },
				},
				account: { id: accountId },
			} = this.state;

			this.setState({ buttonLoading: true });
			// TODO - remove rateSetId, we are not using in API
			const data = {
				accountId,
				uspsTierConfigId: uspsTierId === 'none' ? null : uspsTierId,
			};

			await adminAccountService.updateUSPSTierForAccount(data);

			const currentTierConfig = this.state.uspsTierConfigs.find((x) => x.id === this.state.uspsTierConfig.selected?.id);

			this.setState((prevState: models.ICustomerAccountDetailsState) => ({
				buttonLoading: false,
				uspsTierConfig: {
					...prevState.uspsTierConfig,
					current: {
						...currentTierConfig, 
						numberOfAssociatedAccounts : currentTierConfig.numberOfAssociatedAccounts++
					},
				},
			}));

			this.props.openSnackBar(
				this.props.intl.formatMessage({
					id: 'app.snackbar.usps-tier-config-updated-successfully',
				})
			);
		} catch (err) {
			this.setState({ buttonLoading: false });
			if (!Axios.isCancel(err)) {
				this.props.openSnackBar(sharedService.parseError(err.data), SnackBarVariants.Error);
			}
		}
	};

	private updateAccountStatus = (status: AccountStatusEnum) => {
		this.setState((prevState: ICustomerAccountDetailsState) => ({
			account: { ...prevState.account, status },
		}));
	};

	private getAllUsersByAccountIdForAdmin = async (accountId: string) => {
		const res = await adminAccountService.getAllUsersByAccountIdForAdmin(accountId);
		const treeTableData = this.prepareTreeTableData(res);

		this.setState((prevState) => ({
			users: prevState.users.concat(...treeTableData),
		}));
	};

	/**
	 * Return ITreeTableData
	 */
	private prepareTreeTableData = (users: models.IAccountUserResponseVM[]): models.IAdminAccountUserTreeTableData[] => {
		const treeTableData: models.IAdminAccountUserTreeTableData[] = [];
		for (const user of users) {
			treeTableData.push({
				email: user.email,
				userName: user.userName,
				name: user.name,
				id: user.id,
				userRole: user.userRole,
				lastLoginDate: user.lastLoginDate,
				joiningDate: user.joiningDate,
				isActivated: user.isActivated,
			});
		}
		return treeTableData;
	};
}

export default withRouter(
	withAxiosCancellation(withSnackBar(withStyles(styles)(injectIntl(AdminAccountDetailsComponent))))
);



// WEBPACK FOOTER //
// ./src/components/admin/customer/admin-account-details.component.tsx